<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'2fa_enforce_modal_title' | translate">
		<a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">
			<strong>{{ "close" | translate }}</strong>
		</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section mod-wide pt-25 min-h-400">
			<div class="center-block max-w-550 text-center mb-30">
				<div class="justify-center text-center">
					<div class="twofa-symbol mod-blue mb-20 mt-70 text-center">
						<span class="bpi__icon-lock"></span>
					</div>
				</div>
				<h2 class="mt-20 mb-0 max-w-468 center-block text-center">
					{{ "2fa_enforce_modal_header" | translate }}
				</h2>
				<p class="mb-15 mt-20 font-size-17">{{ "2fa_enforce_modal_description" | translate }}</p>
			</div>
			<button class="btn btn-primary center-block text-center mt-20 min-w-135font-size-15" (click)="onStart2FA()">
				{{ "2fa_enforce_modal_set_button" | translate }}
			</button>
			<div class="text-center mt-10 mb-40">
				<a (click)="onCancel2FA()" class="custom-gray-href">{{ "2fa_enforce_modal_cancel" | translate }}</a>
			</div>
		</div>
	</div>
</div>
